import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/authSlice";
import { logoWhite, logoBig } from "../../assets/images";
import { FaUser } from "react-icons/fa";

const SignIn = () => {
  const [username, setusername] = useState();
  const [password, setPassword] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, isLoading } = useSelector((state) => state.auth);

  const handleSignIn = (e) => {
    e.preventDefault();
    if (username && password) {
      dispatch(login({ username, password }));
    }
  };
  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (token) {
      navigate("/shop");
    }
  }, [isLoading, navigate]);
  return (
    <div className="w-full h-screen flex flex-col lg:flex-row items-center lg:items-stretch lg:justify-center">
      {/* Logo Section */}
      <div className="fixed top-0 w-full bg-primeColor flex items-center justify-center">
        <img src={logoWhite} alt="logo" className="w-40 p-2" />
      </div>
      <div className="w-full flex items-center justify-center pt-10 lg:py-0">
        <div className="px-10 flex flex-col items-center">
          <Link to="/">
            <img
              src={logoBig}
              alt="logo"
              className="hidden lg:block lg:h-[600px] lg:w-[800px] object-cover"
            />
          </Link>
        </div>
      </div>

      {/* Form Section */}
      <div className="w-full lg:w-1/2 h-full">
        <form
          className="w-full lgl:w-[450px] h-full flex items-center justify-center"
          onSubmit={handleSignIn}
        >
          <div className="px-6 py-4 w-full flex flex-col lg:justify-center overflow-y-scroll scrollbar-thin scrollbar-thumb-primeColor">
            <h1 className="text-[36px] text-center font-semibold  mb-4">
              WELCOME
            </h1>
            <p className=" text-center font-bold text-[16px] mb-4">
              User Login
            </p>
            <div className="flex flex-col gap-3">
              {/* username */}
              <div className="flex flex-col gap-0.5">
                <p className="text-[11px] font-semibold ">
                  User ID<span className="text-red-500"> *</span>
                </p>
                <input
                  onChange={(e) => setusername(e.target.value)}
                  value={username}
                  required
                  className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal  border-[1px] border-gray-400 outline-none"
                  type="username"
                  placeholder="User ID"
                />
              </div>

              {/* Password */}
              <div className="flex flex-col gap-0.5">
                <p className="text-[11px] font-semibold ">
                  Password<span className="text-red-500"> *</span>
                </p>
                <input
                  required
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal  border-[1px] border-gray-400 outline-none"
                  type="password"
                  placeholder="Password"
                />
              </div>

              {/* General Error Message */}
              {error && (
                <p className="text-sm text-red-500 font-titleFont font-semibold">
                  {error}
                </p>
              )}

              <button
                type="submit"
                className={`${
                  isLoading
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-[#f2f2f2] text-primeColor"
                } w-fit flex justify-center items-center gap-2 text-[12px] border-primeColor border-[1px] mx-auto px-5 py-1 font-medium   duration-300`}
                disabled={isLoading}
              >
                <FaUser /> {isLoading ? "Signing In..." : "Login"}
              </button>
              <p className="text-center text-[12px] flex gap-4 mt-4  text-primeColor font-semibold items-center justify-center">
                <span>Anytime</span>
                <span className="text-[20px]">•</span>
                <span>Anywhere</span>
                <span className="text-[20px]">•</span>
                <span>Any Device</span>
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
